import { render, staticRenderFns } from "./InputValor.vue?vue&type=template&id=943eaab4&scoped=true"
import script from "./InputValor.vue?vue&type=script&lang=js"
export * from "./InputValor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../paylogos-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "943eaab4",
  null
  
)

export default component.exports